import { render } from "./ClientData.vue?vue&type=template&id=40a6cd30&scoped=true"
import script from "./ClientData.vue?vue&type=script&lang=js"
export * from "./ClientData.vue?vue&type=script&lang=js"

import "./ClientData.vue?vue&type=style&index=0&id=40a6cd30&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a6cd30"]])

export default __exports__